import React from 'react';
import { ProgressBar } from '@themesberg/react-bootstrap';

class GetProcess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            direction: 1,
            show: props.show || false
        };
        this.ticking = false;
        this.interval = null;
    }

    componentDidMount() {
        if (this.state.show) {
            this.startProgress();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.show && !this.interval) {
            this.startProgress();
        }

        if (this.ticking) {
            this.ticking = false;

            if (this.state.progress === 100) {
                setTimeout(() => this.setState({ direction: -2 }), 40);
            } else if (this.state.progress === 0) {
                setTimeout(() => this.setState({ direction: 2 }), 40);
            }
        }
    }

    startProgress() {
        this.interval = setInterval(() => {
            this.setState(prevState => {
                let next = prevState.progress + prevState.direction;
                if (next >= 100) next = 100;
                if (next <= 0) next = 0;
                this.ticking = true;
                return { progress: next };
            });
        }, 80);
    }

    stopProgress() {
        clearInterval(this.interval);
        this.interval = null;
    }

    present = () => {
        this.setState({ show: true, progress:0, direction:1 }, () => this.startProgress());
    };

    dismiss = () => {
        this.setState({ show: false }, () => this.stopProgress());
    };

    render() {
        let { show, progress } = this.state;
        return show ? (
            <ProgressBar
                label="Preparing data.."
                variant="info"
                style={{height:'13px', fontSize:'11px', zIndex:10000}}
                className="p-0 m-0 position-relative bg-primary"
                now={progress}
            />
        ) : null;
    }
}

// Enable useRef on this class
export default React.forwardRef((props, ref) => (
    <GetProcess {...props} ref={ref} />
));

